import { render, staticRenderFns } from "./ModalOver130Under70.vue?vue&type=template&id=7cf3256c&scoped=true"
import script from "./ModalOver130Under70.vue?vue&type=script&lang=js"
export * from "./ModalOver130Under70.vue?vue&type=script&lang=js"
import style0 from "./ModalOver130Under70.vue?vue&type=style&index=0&id=7cf3256c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf3256c",
  null
  
)

export default component.exports